import { createSearchSelect } from './searchSelect'
import { createNativeSelect } from './nativeSelect'
import { positionSelectPanel } from './position'

export function installSearchSelects(Vue, Base) {
  Base.props.appendToBody.default = true
  Base.props.calculatePosition.default = positionSelectPanel
  Base.props.dropdownShouldOpen.default = select => !select.noDrop && select.open
  Base.props.filterBy.default = (option, label, search) => {
    const text = value => String(value == null ? '' : value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR')
    return text(label).includes(text(search))
  }
  const SearchSelect = Vue.extend(createSearchSelect(Base))
  Vue.component('v-select', SearchSelect)
  Vue.component('search-select', createNativeSelect(SearchSelect))
}
